import { ButtonList } from '@dixa/lib-shared-habla';
import { useAtomValue } from 'jotai';
import {
  Category,
  ParentRef,
} from 'lib-knowledge-management-common/models/types';
import { useModal } from 'lib-knowledge-modal';
import { collectionIdAtom } from 'models/collectionStore';

import { ArticleAddModal } from '../../../modals/components/articleAddModal';

import { CategoryAddModal } from './modals/categoryAddModal';
import s from './styles.module.scss';

const CATEGORY_DEPTH_MAX = 4;

function CategoryInsertsMenu({
  category,
  depth,
}: {
  category: Category;
  depth: number;
}): JSX.Element {
  const collectionId = useAtomValue(collectionIdAtom);
  const { showModal } = useModal();
  const presetParent: ParentRef = {
    __typename: 'Category',
    id: category.id,
  };

  return (
    <ButtonList>
      <div className={s.buttonGroup}>
        <ButtonList.Item
          icon="file-text"
          onClick={() => {
            if (!collectionId)
              throw new Error('No collectionId found creating article');
            showModal(ArticleAddModal, {
              type: 'add_article',
              presetParent,
            });
          }}
        >
          Add article
        </ButtonList.Item>
        {depth < CATEGORY_DEPTH_MAX && (
          <ButtonList.Item
            icon="folder"
            onClick={() => showModal(CategoryAddModal, { presetParent })}
          >
            Add category
          </ButtonList.Item>
        )}
      </div>
    </ButtonList>
  );
}

export default CategoryInsertsMenu;
